import React from "react";
import styled from "styled-components";
import Container from "../Components/Container";
import Row from "../Components/Row";
import LogoBlue from "../assets/images/logo.svg";

const Subtitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 0px;
`;

const TermsOfUse = () => {
  return (
    <Container
      style={{ lineHeight: "35px", color: "#ffffff", marginTop: "200px" }}
    >
      <h1>Termos de Uso – Alfred</h1>
      <p>
        <strong>Última atualização:</strong> 11/12/2025
      </p>

      <p>
        Bem-vindo ao Alfred, uma plataforma de criação, configuração e operação
        de agentes de atendimento automatizado. Ao utilizar o Alfred, você
        concorda integralmente com estes Termos de Uso. Leia atentamente todas
        as cláusulas antes de continuar seu uso do serviço.
      </p>

      <h2>1. Objeto do Serviço</h2>
      <p>
        O Alfred fornece uma plataforma que permite ao usuário criar,
        personalizar e operar agentes virtuais para atendimento via WhatsApp e
        outros canais.
      </p>

      <p>O serviço abrange funcionalidades como:</p>
      <ul>
        <li>Criação e configuração de agentes;</li>
        <li>Gestão de fluxos e comportamento do agente;</li>
        <li>Conexão com API ou número WhatsApp via provedores homologados;</li>
        <li>Painel administrativo e funcionalidades relacionadas.</li>
      </ul>

      <p>
        O Alfred não envia mensagens em nome próprio. Toda comunicação ocorre
        exclusivamente em nome e responsabilidade do usuário.
      </p>

      <h2>2. Responsabilidade do Usuário</h2>
      <p>O usuário é total e exclusivamente responsável por:</p>

      <h3>2.1. Conteúdo e comportamento do agente</h3>
      <ul>
        <li>Toda e qualquer mensagem enviada pelo agente configurado;</li>
        <li>
          Tom de voz, regras, respostas, fluxos e comportamentos definidos no
          painel;
        </li>
        <li>
          Configurações feitas pelo usuário ou por terceiros autorizados por
          ele;
        </li>
        <li>
          Informações fornecidas ao agente, incluindo textos, prompts,
          instruções e dados.
        </li>
      </ul>

      <p>
        O Alfred não revisa, não controla e não se responsabiliza pelo conteúdo
        produzido pelo agente virtual, mesmo quando derivado de IA.
      </p>

      <h3>2.2. Consentimento, opt-in e direito de saída</h3>
      <p>
        Para reduzir riscos de denúncia, bloqueio e violação de políticas de
        plataformas de mensagens, o usuário se compromete a:
      </p>
      <ul>
        <li>
          Enviar mensagens apenas para contatos com consentimento explícito e
          verificável (opt-in);
        </li>
        <li>
          Evitar disparos para listas frias, bases compradas, raspadas ou sem
          autorização;
        </li>
        <li>
          Manter um canal de saída claro em mensagens de campanha/recorrência
          (ex.: <strong>&quot;Digite SAIR para parar&quot;</strong>) e respeitar
          o pedido imediatamente;
        </li>
        <li>
          Garantir que o destinatário tenha meio simples de bloquear/cancelar o
          recebimento de comunicações.
        </li>
      </ul>

      <h3>2.3. Padrões de conteúdo e boas práticas anti-spam</h3>
      <p>
        O usuário entende que conteúdo e padrões repetitivos podem aumentar
        denúncias e risco de bloqueio. Assim, compromete-se a:
      </p>
      <ul>
        <li>
          Evitar envio massivo com textos idênticos e padrões previsíveis;
        </li>
        <li>
          Variar templates e abordagens, priorizando conversa contextual e
          utilidade real ao destinatário;
        </li>
        <li>
          Evitar linguagem, promessas e termos que possam ser interpretados como
          fraude, spam ou abuso;
        </li>
        <li>
          Respeitar sazonalidades e momentos de maior sensibilidade/moderação,
          reduzindo volume e intensidade de campanhas quando necessário.
        </li>
      </ul>

      <h2>3. Uso do WhatsApp e Riscos de Bloqueio</h2>
      <p>O usuário reconhece e concorda que:</p>
      <ul>
        <li>
          O WhatsApp possui regras e políticas próprias para uso de automações e
          mensagens;
        </li>
        <li>
          O Alfred não possui qualquer relação com o WhatsApp, Meta ou empresas
          associadas;
        </li>
        <li>
          O uso inadequado do agente (como spam, mensagens não solicitadas,
          automações abusivas etc.) pode resultar em advertências, limitações ou
          suspensão/bloqueio permanente do número vinculado.
        </li>
      </ul>

      <h3>3.1. Bloqueios podem ocorrer mesmo sem envio</h3>
      <p>
        O usuário reconhece que bloqueios ou restrições podem ocorrer não apenas
        por volume, mas também por fatores técnicos e comportamentais, inclusive
        <strong> pela forma de conexão</strong> (ex.: login, QR Code, padrões de
        uso), independentemente do Alfred.
      </p>

      <h3>3.2. Fatores que aumentam risco de bloqueio</h3>
      <p>
        O usuário entende que o risco de bloqueio pode aumentar, entre outros,
        por:
      </p>
      <ul>
        <li>
          Envio para muitos destinatários diferentes em curto período, sem
          histórico de interação;
        </li>
        <li>
          Alta taxa de denúncias, bloqueios e marcações como spam pelos
          destinatários;
        </li>
        <li>
          Conteúdo sensível, promocional ou interpretável como golpe/fraude;
        </li>
        <li>
          Uso de número recém-criado/recente, com baixo histórico de conversas
          orgânicas;
        </li>
        <li>
          Reutilização de padrões (nome, foto, descrição, templates) associados
          a números previamente bloqueados;
        </li>
        <li>
          Problemas externos como qualidade/relacionamento do IP/ASN, histórico
          do número e sinais de atividade suspeita.
        </li>
      </ul>

      <h3>3.3. Estratégia de implantação e aquecimento do número</h3>
      <p>
        O usuário reconhece que boas práticas de implantação reduzem risco, e se
        compromete a adotar medidas como:
      </p>
      <ul>
        <li>
          Aquecimento/maturação do número com uso orgânico antes de automações;
        </li>
        <li>
          Completar perfil (nome, foto e descrição) antes do primeiro envio
          automatizado;
        </li>
        <li>
          Evitar iniciar automação imediatamente após registrar o número;
        </li>
        <li>
          Manter comportamento realista de atendimento (priorizar respostas e
          interação genuína).
        </li>
      </ul>

      <h3>3.4. Responsabilidade exclusiva</h3>
      <p>
        Qualquer bloqueio, restrição ou penalidade aplicada pelo WhatsApp é de
        responsabilidade exclusiva do usuário, incluindo:
      </p>
      <ul>
        <li>Bloqueio temporário ou permanente do número;</li>
        <li>Perdas de acesso;</li>
        <li>Prejuízos financeiros, de reputação ou operacionais.</li>
      </ul>

      <p>
        O Alfred não oferece garantia de que o número do usuário permanecerá
        ativo junto ao WhatsApp, nem se responsabiliza por qualquer dano
        decorrente do uso da plataforma.
      </p>

      <h2>4. Conformidade Legal</h2>
      <p>
        O usuário se compromete a utilizar o Alfred respeitando todas as leis
        aplicáveis, incluindo:
      </p>
      <ul>
        <li>LGPD;</li>
        <li>Código de Defesa do Consumidor;</li>
        <li>Políticas da Meta/WhatsApp Business;</li>
        <li>Legislação comercial, civil e penal.</li>
      </ul>

      <p>
        O Alfred não se responsabiliza por irregularidades cometidas pelo
        usuário, incluindo coleta indevida de dados, envio não autorizado de
        mensagens ou descumprimento de obrigações legais.
      </p>

      <h2>5. Propriedade Intelectual</h2>
      <p>
        Todo o software, design, interface, algoritmos e documentação do Alfred
        são protegidos por direitos autorais e pertencem exclusivamente aos seus
        desenvolvedores. É proibido copiar, distribuir, modificar ou reproduzir
        qualquer parte da plataforma sem autorização prévia.
      </p>

      <h2>6. Limitação de Responsabilidade</h2>
      <p>O Alfred não se responsabiliza por:</p>
      <ul>
        <li>
          Perdas financeiras, comerciais ou operacionais decorrentes do uso da
          plataforma;
        </li>
        <li>Erros, falhas, atrasos ou indisponibilidade dos serviços;</li>
        <li>Erros cometidos pelo agente configurado pelo próprio usuário;</li>
        <li>
          Problemas causados por integrações, provedores externos ou plataformas
          de terceiros.
        </li>
      </ul>

      <p>
        Em nenhuma hipótese o Alfred será responsável por prejuízos indiretos,
        perda de lucro, perda de dados ou danos emergentes.
      </p>

      <h2>7. Suporte e Atualizações</h2>
      <p>
        O Alfred oferece suporte conforme disponibilizado em seu canal oficial.
        A plataforma poderá ser atualizada, alterada ou descontinuada a qualquer
        momento, sem obrigação de aviso prévio.
      </p>

      <h2>8. Cancelamento e Encerramento</h2>
      <p>O usuário pode cancelar o uso da plataforma a qualquer momento.</p>
      <p>O Alfred poderá suspender contas em casos como:</p>
      <ul>
        <li>Uso abusivo;</li>
        <li>Violação destes Termos;</li>
        <li>Riscos de segurança;</li>
        <li>Atividade suspeita.</li>
      </ul>

      <h2>9. Alterações nos Termos</h2>
      <p>
        O Alfred poderá atualizar estes Termos de Uso periodicamente. O uso
        contínuo da plataforma após as mudanças implica concordância com os
        novos termos.
      </p>

      <h2>10. Aceite</h2>
      <p>Ao utilizar o Alfred, o usuário declara que:</p>
      <ul>
        <li>Leu e compreendeu todas as cláusulas;</li>
        <li>Concorda integralmente com os Termos de Uso;</li>
        <li>
          Assume total responsabilidade pelo comportamento do agente e pelo uso
          do WhatsApp vinculado;
        </li>
        <li>
          Compromete-se a obter e manter consentimento (opt-in) e respeitar
          pedidos de saída (opt-out) de forma imediata;
        </li>
        <li>
          Reconhece que bloqueios podem ocorrer por fatores externos, técnicos e
          comportamentais, inclusive sem envio de mensagens.
        </li>
      </ul>

      <Subtitle style={{ fontSize: "16px" }}>contato@alfredchat.com.br.</Subtitle>
      <Row
        xs="1fr 1fr"
        sm="1fr 1fr"
        md="1fr 1fr"
        lg="1fr 1fr"
        xl="1fr 1fr"
        style={{
          marginTop: "100px",
          marginBottom: "30px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <img src={LogoBlue} width={"53px"} alt="logo" />
        <span style={{ fontWeight: 200, textAlign: "right" }}>
          © 2025 Alfred Chat
        </span>
      </Row>
    </Container>
  );
};

export default TermsOfUse;